<template>
  <v-container v-if="props.locationId && location">
    <v-row class="fix-row">
      <v-col
        cols="8"
        class="bordered bg-white">
        <CalcInputNumber
          :id="props.locationId"
          class="mb-4"
          field="costs_of_the_area_location"
          :rules="[positive]" />

        <CalcInputNumber
          :id="props.locationId"
          class="mb-4"
          field="calculated_interest_rate_percentage_location"
          max="100"
          min="0"
          :rules="[percents, positive]"
          step="0.01" />

        <CalcInputNumber
          :id="props.locationId"
          class="mb-4"
          field="electricity_price_location"
          :rules="[positive]" />
      </v-col>
      <v-col
        id="cost_notes_col"
        class="bordered bg-white"
        cols="4">
        <NotesEditor
          :id="locationId"
          field="cost_notes_location"
          :placeholder="$t('entities.location.fields.cost_notes_location')" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { useTranslation } from "i18next-vue";

import { useCommonRules } from "@/validations/common";
import { ref, onMounted } from "vue";
import { useSpaceStore } from "@/stores/spaceStore";
import NotesEditor from "@/components/Elements/NotesEditor.vue";
import CalcInputNumber from "@/components/Elements/CalcInputNumber.vue";

const { t } = useTranslation();
const location = ref(null);
const { positive, percents } = useCommonRules(t);

const spaceStore = useSpaceStore();

const props = defineProps({
  locationId: {
    type: String,
    required: true
  }
});
onMounted(() => {
  location.value = spaceStore.getElement(props.locationId);
});
</script>

<style scoped>
#cost_notes_col {
  height: 260px !important;
  margin-left: 12px;
  padding: 16px;
  /* margin-top: 12px; */
  margin-right: -12px;
  padding-bottom: 84px;
}

.fix-margin {
  margin: 0 -16px;
  padding: 16px;
}

.fix-row {
  margin-right: -4px;
}
</style>
